import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { VisierAnalytics } from 'Deer/components/Visier/VisierAnalytics';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';

import { COMPANY_VISIER_ANALYSIS } from 'constants/ProjectConstants';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

const EmbeddedEngagementAnalytics = ({ headerLabel }: { headerLabel: string }) => {
  const { l3Options: tabs } = useRouteToNavLevels();

  return (
    <>
      <PlainTextHeader>{headerLabel}</PlainTextHeader>
      <PageTabbedNavigationV1 tabs={tabs} />
      <VisierAnalytics id={COMPANY_VISIER_ANALYSIS[2].id} />
    </>
  );
};

export { EmbeddedEngagementAnalytics };
